import React from "react";
import { LifeBuoy } from "lucide-react";

function renderHoursWithBold(text) {
  if (!text) return null;
  // Split by **bold** markers
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (/^\*\*[^*]+\*\*$/.test(p)) {
      return <strong key={i} className="text-foreground">{p.slice(2, -2)}</strong>;
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
}

function renderLine(line, i) {
  const s = String(line || "").trim();
  if (!s) return null;
  const isEmail = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s);
  const digitCount = (s.match(/\d/g) || []).length;
  const isPhone = !isEmail && digitCount >= 6;
  if (isEmail) {
    return (
      <a key={i} href={`mailto:${s}`} className="text-primary hover:underline block truncate">
        {s}
      </a>
    );
  }
  if (isPhone) {
    const tel = s.replace(/[^0-9+]/g, "");
    return (
      <a key={i} href={`tel:${tel}`} className="text-primary hover:underline block">
        {s}
      </a>
    );
  }
  return <div key={i} className="text-muted-foreground">{s}</div>;
}

export default function SupportPanel({ contacts = [], intro }) {
  return (
    <div className="rounded-xl border border-border bg-card p-5">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
          <LifeBuoy className="w-4 h-4 text-primary" />
        </div>
        <h3 className="text-[15px] font-semibold">Support and Escalations</h3>
      </div>
      <p className="mt-2 text-[12.5px] text-muted-foreground">
        {intro || "Reach out to the following contacts for technical support."}
      </p>
      <div className="mt-4 divide-y divide-border">
        {contacts.map((c) => {
          const lines = (c.lines && c.lines.length ? c.lines : [c.email, c.phone].filter(Boolean));
          return (
            <div key={c.id} className="py-3 first:pt-0 last:pb-0">
              <div className="grid grid-cols-3 gap-3">
                <div className="col-span-1">
                  <div className="text-[12.5px] font-semibold text-foreground leading-tight">{c.name}</div>
                </div>
                <div className="col-span-1 text-[12px] text-muted-foreground leading-snug">
                  {renderHoursWithBold(c.hours)}
                </div>
                <div className="col-span-1 text-[12px] leading-snug space-y-0.5">
                  {lines.map(renderLine)}
                  {c.note && <div className="text-muted-foreground mt-0.5">{c.note}</div>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
